import { type SelectedAddress } from "@jti/commerce";
import type { ExternalShippingCarrierAddress } from "@jti/commerce-types";

export const prepareAddressViewFormat = (address: ExternalShippingCarrierAddress): SelectedAddress => {
  return {
    street: address.streetName,
    city: address.city,
    country: address.countryName,
    postCode: address.postCode,
  };
};
